export default {
  'login.signIn': 'Sign In',
  'login.companySelfCare': 'Company Self-Care',
  'login.mobileNumber': 'Mobile Number',
  'login.OTP': 'OTP',
  'login.GET': 'GET',
  'login.here': 'here',
  'login.tcMessage': 'Login TC Message',
  'login.only.number': 'Only numbers can be entered.',
  'login.verification': 'Verification Code Sent Successfully!',
  'login.description':
    'If you click login, you accepted T&C. If you want to view T&C, please click',
  'login.forgetPassWord': 'Forgot Password?',
  'login.userName': 'User Name or Email or Mobile Number',
  'login.password': 'Password',
  'login.login': 'Login',
  'login.with': 'Login with:',
  'login.next': 'Next',
  'login.forgetPassword': 'Forgot Password',
  'login.userName.required': 'Please enter your User Name or Email or Mobile Number!',
  'login.password.required': 'Please enter your password!',
  'login.password.rules': 'Password Rule',
  'login.email.required': 'Please enter your Email!',
  'login.otp.required': 'Please enter the OTP!',
  'login.confirmPwd': "Input doesn't match new password!",
  'login.success': 'Login Success',
  'logout.normal': 'Logout Normal',
  'logout.timeout': 'Logout Timeout',
};
